import type { SerializableDynamicValue } from "~/Configurators/common/v2/types";
import * as RailCstic from "~/Configurators/Rail/v2/configuration/classic/RailsCstics";

export const RailsDefaultValues: Record<string, SerializableDynamicValue<string>> = {
  [RailCstic.Series]: "",
  [RailCstic.Size]: "",
  [RailCstic.Coating]: "/",
  [RailCstic.Accuracy]: [
    {
      condition: {
        type: "equals",
        cstic: RailCstic.Series,
        value: "TSX",
      },
      value: "G2",
    },
    {
      condition: {
        type: "equals",
        cstic: RailCstic.Series,
        value: ["TKSD", "TKVD", "TKVD..-W"],
      },
      value: "G3",
    },
  ],
  [RailCstic.MountingHoleType]: "/",
  [RailCstic.ClosingPlugs]: [
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: RailCstic.Series,
            value: "TSX",
          },
          {
            type: "equals",
            cstic: RailCstic.Size,
            value: ["25", "35", "45", "55", "65"],
          },
        ],
      },
      value: "KA..TN/B",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: RailCstic.Series,
            value: "TSX",
          },
          {
            type: "equals",
            cstic: RailCstic.Size,
            value: "100",
          },
        ],
      },
      value: "KA..M",
    },
    {
      condition: {
        type: "equals",
        cstic: RailCstic.Series,
        value: ["TKSD", "TKVD"],
      },
      value: "KA..TN/B",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: RailCstic.Series,
            value: "TKVD..-W",
          },
          {
            type: "equals",
            cstic: RailCstic.Size,
            value: ["15", "20"],
          },
        ],
      },
      value: "KA..TN/A",
    },
    {
      condition: {
        type: "and",
        value: [
          {
            type: "equals",
            cstic: RailCstic.Series,
            value: "TKVD..-W",
          },
          {
            type: "equals",
            cstic: RailCstic.Size,
            value: ["25", "30", "35"],
          },
        ],
      },
      value: "KA..TN/B",
    },
  ],
  [RailCstic.GuidewayDesign]: [
    {
      condition: {
        type: "equals",
        cstic: RailCstic.Series,
        value: "TKVD..-W",
      },
      value: "W",
    },
    {
      condition: {
        type: "not",
        value: {
          type: "equals",
          cstic: RailCstic.Series,
          value: "TKVD..-W",
        },
      },
      value: "/",
    },
  ],
  [RailCstic.LocatingFace]: "O",
};
